import { Button } from '@mui/material';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { I18n } from 'utils/i18n';
import isTeamAdminSelector from 'store/selectors/isTeamAdmin';
import channel from 'store/app/ui/drawers/channel/action';
import useActions from 'utils/useActions';

const NewChannelButton = () => {
  const isTeamAdmin = useSelector(isTeamAdminSelector);
  const openChannelDrawer = useActions(channel.open);

  if (!isTeamAdmin) return null;

  return (
    <Button
      onClick={openChannelDrawer}
      color="primary"
      fullWidth
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        borderRadius: 0,
        color: 'primary.dark',
      }}
    >
      {I18n.t('ChannelsPanel.New channel')}
    </Button>
  );
};

export default memo(
  NewChannelButton,
  (prevProps, nextProps) => prevProps.isTeamAdmin === nextProps.isTeamAdmin,
);
